import serviceInsumoObra from '../services/serviceInsumoObra'

export default function formataDescricaoInsumo(insumo) {
  let descricaoInsumo = ''

  console.log(insumo)

  if (typeof insumo !== 'string') {
    if (insumo.insumo) {
      if (!insumo.insumo.descricaoPai && !insumo.insumo.descricao_pai) {
        let hasFather = String(insumo.codigo).split('.')

        if (hasFather.length > 1) {
          serviceInsumoObra.buscaCod(hasFather[0]).then((res) => {
            insumo.descricaoPai = res.data.data.descricao
          })
        }
      }
    } else {
      if (!insumo.descricaoPai && !insumo.descricao_pai) {
        let hasFather = String(insumo.codigo).split('.')

        if (hasFather.length > 1) {
          serviceInsumoObra.buscaCod(hasFather[0]).then((res) => {
            insumo.descricaoPai = res.data.data.descricao
          })
        }
      }
    }

    if (
      typeof insumo.insumo !== 'string' &&
      insumo.insumo !== null &&
      insumo.insumo !== undefined
    ) {
      if (
        insumo.insumo.descricaoPai !== null ||
        insumo.insumo.descricaoPai !== undefined
      ) {
        if (insumo.insumo.descricaoPai && !insumo.descricaoPai) {
          insumo.descricaoPai = insumo.insumo.descricaoPai
        }
      }

      if (insumo.insumo.descricao_pai !== null) {
        if (insumo.insumo.descricao_pai && !insumo.descricao_pai) {
          insumo.descricao = insumo.insumo.descricao
        }
      }

      if (insumo.insumo.descricao !== null) {
        if (insumo.insumo.descricao) {
          insumo.descricao = insumo.insumo.descricao
        }
      }
    }

    if (insumo.descricao_pai) {
      insumo.descricaoPai = insumo.descricao_pai
    }

    if (insumo.descricaoPai) {
      descricaoInsumo = `${insumo.descricaoPai} - ${insumo.descricao}`
    } else {
      descricaoInsumo = insumo.descricao
    }
  } else {
    descricaoInsumo = insumo
  }

  let existeCodigo = []

  if (descricaoInsumo) {
    existeCodigo = descricaoInsumo.split('-')
  }

  if (existeCodigo.length > 1) {
    let isNumber = Number(existeCodigo[0].trim())
    isNumber = !Number.isNaN(isNumber)

    if (isNumber || existeCodigo[0].trim() === 'undefined') {
      descricaoInsumo = ''
      descricaoInsumo = existeCodigo[1]

      existeCodigo.forEach((item, i) => {
        if (i > 1) {
          descricaoInsumo += ` - ${item}`
        }
      })

      descricaoInsumo = descricaoInsumo.trim()
    }
  }

  if (!existeCodigo) {
    if (descricaoInsumo.includes(insumo.insumo.descricao)) {
      descricaoInsumo = descricaoInsumo.replace(insumo.insumo.descricao, '')

      descricaoInsumo = descricaoInsumo.trim()

      descricaoInsumo += ` - ${insumo.insumo.descricao}`
    }
  }

  return descricaoInsumo
}
